/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-13 10:50:46
 * @LastEditors: linxi
 * @LastEditTime: 2025-01-06 17:40:14
 */
import { Button, Cascader, Checkbox, Col, Form, Input, Row, Select, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import { SearchOutlined, CaretDownFilled } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { pageSupplier, selectSupplierdata } from '../wms/supplierSlice'
import { useCascaderDropdownRender } from '../storesearch/query'
import {
  DateRangeFieldName,
  DateRangeType,
  DateSelect,
  getDateRange,
} from '../../compnents/form/DateSelect'
import { DurgSalesParams } from '../../services/durgSales'
import {
  BillingCategories,
  BillingCategoryName,
  InvoiceBillingCategories,
} from '../../models/billingCategory'
import { Department } from '../../models/department'
import { DepartmentDate, selectDepartData } from '../putstorage/putstorageSlice'

import {
  getAllUserName,
  sleectUserData,
} from '../putstorelist/putstorelistSlice'
import {
  setmaterialsCategory,
  setotcTag,
  selectOtctag,
  selectmaterialsCategory,
} from './DurgsalesSlice'
import { setDurgSaleCurrent } from './DurgsalesSlice'
import styles from './durgsales.module.css'
import {
  getDoctorsInDepartment,
  selectDoctors,
  setDoctors,
} from '../registration/register/registerSlice'
import { selectInsuranceArray } from '../../app/applicationSlice'
import moment from 'moment'
const { Option } = Select

// // 将 insuranceType 字段的值统一规范化为 any[][] 格式
// // 商品类别用 normalizeMaterialsCategory，险种类型同理
const normalizeInsuranceType = (value: any) => {
  if (!value) return []
  if (Array.isArray(value) && value.length === 0) return []
  if (Array.isArray(value) && Array.isArray(value[0])) return value
  if (Array.isArray(value)) return [value]
  return []
}
//
// // 从 any[][] 格式的值中提取后端需要的参数
// // 所有选中的节点，无论一级还是二级，统一取最后一个值，逗号拼接成 insuranceType
// // 例：[['yibao', '0'], ['yibao', '1'], ['ZIFEI']] → insuranceType: '0,1,ZIFEI'
// // 例：[['yibao']] → insuranceType: 'yibao'（全选时直接传父级）
// // 关键：如果某个父级下所有子节点都已选中，则只传父级本身，不传子节点值
// // 例：[['yibao', '0'], ['yibao', '1'], ['yibao', '2'], ['yibao', '3']] → insuranceType: 'yibao'
// const getInsuranceTypeParams = (value: any, treeData?: any[]) => {
//   const list = normalizeInsuranceType(value)
//   if (!list.length) return { insuranceType: undefined }
//
//   // 收集一级节点值和二级节点值
//   const topLevelValues: string[] = []
//   const childValues: string[] = []
//   const parentChildrenMap: Record<string, Set<string>> = {}
//
//   for (const item of list) {
//     if (!Array.isArray(item) || item.length === 0) continue
//     if (item.length === 1) {
//       // 一级节点：['yibao']
//       const val = String(item[0])
//       if (!topLevelValues.includes(val)) {
//         topLevelValues.push(val)
//       }
//       if (!parentChildrenMap[val]) parentChildrenMap[val] = new Set()
//     } else {
//       // 二级节点：['yibao', '0']
//       const parent = String(item[0])
//       const child = String(item[1])
//       if (!parentChildrenMap[parent]) parentChildrenMap[parent] = new Set()
//       parentChildrenMap[parent].add(child)
//       childValues.push(child)
//     }
//   }
//
//   // 找出父级下所有子节点都已选中的父级
//   const allChildParents = new Set<string>()
//   for (const [parent, children] of Object.entries(parentChildrenMap)) {
//     if (treeData) {
//       const node = treeData.find((v: any) => v.value === parent)
//       if (node?.children && children.size >= node.children.length) {
//         allChildParents.add(parent)
//       }
//     } else {
//       // 没有 treeData 时，子节点数超过1个就认为是全选（yibao 有4个子节点）
//       if (children.size > 1) {
//         allChildParents.add(parent)
//       }
//     }
//   }
//
//   // 按父级维度构建最终结果
//   const resultValues: string[] = []
//   for (const parent of Object.keys(parentChildrenMap)) {
//     if (allChildParents.has(parent)) {
//       // 全选 → 只传父级
//       if (!resultValues.includes(parent)) {
//         resultValues.push(parent)
//       }
//     } else {
//       // 未全选 → 传实际选中的子节点
//       for (const child of Array.from(parentChildrenMap[parent])) {
//         if (!resultValues.includes(child)) {
//           resultValues.push(child)
//         }
//       }
//     }
//   }
//
//   // 一级节点中不属于"全选父级"的也要加入（如 ZIFEI）
//   for (const v of topLevelValues) {
//     if (!allChildParents.has(v) && !resultValues.includes(v)) {
//       resultValues.push(v)
//     }
//   }
//
//   return {
//     insuranceType: resultValues.length ? resultValues.join(',') : undefined,
//   }
// }
//
// // 复用 query.tsx 中相同的 dropdownRender 逻辑
// // 点击一级菜单标题 → 全选/全消该分组下的所有子项
// // 关键：不依赖任何 useState，通过闭包 getValue/setValue 读写 Form 字段
// const useCascaderDropdownRender = (
//   treeData: any[],
//   getValue: () => any[][],
//   setValue: (v: any[][]) => void,
//   onChange: () => void,
// ) => {
//   return React.useCallback(
//     (menus: React.ReactNode) => {
//       // 鼠标悬浮在一级菜单项上自动展开二级菜单
//       const handleHover = (e: React.MouseEvent<HTMLDivElement>) => {
//         const target = e.target as HTMLElement
//         const menuItem = target.closest('.ant-cascader-menu-item') as HTMLElement | null
//         if (!menuItem) return
//         const menu = menuItem.closest('.ant-cascader-menu') as HTMLElement | null
//         if (!menu) return
//         const menuList = menu.parentElement?.querySelectorAll('.ant-cascader-menu')
//         const menuIndex = menuList ? Array.from(menuList).indexOf(menu) : -1
//         // 只处理第一级菜单
//         if (menuIndex !== 0) return
//         // 只处理有子级的可展开项
//         if (!menuItem.classList.contains('ant-cascader-menu-item-expand')) return
//         // 已经展开的跳过
//         if (menuItem.classList.contains('ant-cascader-menu-item-active')) return
//         // 触发展开
//         menuItem.click()
//       }
//
//       // 鼠标移出一级菜单时立即折叠二级菜单
//       const handleMouseOut = (e: React.MouseEvent<HTMLDivElement>) => {
//         const wrapper = e.currentTarget as HTMLElement
//         const allMenus = wrapper.querySelectorAll('.ant-cascader-menu')
//         if (allMenus.length < 2) return
//         const firstMenu = allMenus[0]
//         const secondMenu = allMenus[1]
//
//         const relatedTarget = e.relatedTarget as HTMLElement | null
//         // 鼠标移到了二级菜单上 → 不折叠
//         if (relatedTarget && secondMenu.contains(relatedTarget)) return
//         // 鼠标还在一级菜单内 → 不折叠
//         if (relatedTarget && firstMenu.contains(relatedTarget)) return
//
//         // 鼠标已离开菜单区域 → 折叠
//         const activeItem = firstMenu.querySelector('.ant-cascader-menu-item-active')
//         if (activeItem) {
//           (activeItem as HTMLElement).click()
//         }
//       }
//
//       // 处理一级菜单标题点击（全选/全消）
//       // 只在点击一级菜单的 label 文字时触发全选/全消
//       // 点击 checkbox 或其他区域 → 不拦截，交给 Cascader 自身处理
//       // 注意："全部"(ALL) 的逻辑由 Cascader 的 onChange 处理，这里不拦截
//       const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
//         const target = e.target as HTMLElement
//         const menuItem = target.closest('.ant-cascader-menu-item') as HTMLElement | null
//         if (!menuItem) return
//         const menu = menuItem.closest('.ant-cascader-menu') as HTMLElement | null
//         if (!menu) return
//         const menus = menu.parentElement?.querySelectorAll('.ant-cascader-menu')
//         const menuIndex = menus ? Array.from(menus).indexOf(menu) : -1
//         // 只处理第一级菜单
//         if (menuIndex !== 0) return
//
//         // 点击 checkbox 区域 → 不拦截，交给 Cascader   自己处理
//         if (target.closest('.ant-checkbox-wrapper')) return
//
//         // 只拦截标题文字区域的点击
//         const labelEl = menuItem.querySelector('.ant-cascader-menu-item-content')
//         if (!labelEl || !labelEl.contains(target)) return
//
//         const labelText = labelEl.textContent?.trim()
//         if (!labelText) return
//         const topNode = treeData.find((v) => v.label === labelText)
//         if (!topNode) return
//
//         const currentValue: any[][] = getValue() || []
//         const topVal = topNode.value
//         const children: any[] = topNode.children || []
//
//         // 没有子级 → 不拦截，交给 Cascader 自身处理（单选/展开下一级）
//         if (children.length === 0) return
//
//         // 其他有子级的一级节点：点击标题 → 全选/全消子项
//         const hasTop = currentValue.some((p) => p.length === 1 && p[0] === topVal)
//         const allChildPaths = children.map((c: any) => [topVal, c.value])
//         const allChildSelected = allChildPaths.every((cp) =>
//           currentValue.some((p) => p[0] === cp[0] && p[1] === cp[1]),
//         )
//         const isFullySelected = hasTop && (children.length === 0 || allChildSelected)
//
//         let newValue: any[][]
//         if (isFullySelected) {
//           // 全选状态 → 取消全选：移除该父级及其所有子节点
//           newValue = currentValue.filter(
//             (p) => p[0] !== topVal && !(p.length === 2 && p[0] === topVal),
//           )
//         } else {
//           // 非全选状态 → 全选：清除该父级下已有子节点，加入父级本身 + 所有子节点
//           const withoutTop = currentValue.filter(
//             (p) => p[0] !== topVal && !(p.length === 2 && p[0] === topVal),
//           )
//           newValue = [...withoutTop, [topVal], ...allChildPaths]
//         }
//
//         setValue(newValue)
//         onChange()
//         // 阻止事件冒泡，避免 Cascader 自身再处理导致冲突
//         e.stopPropagation()
//       }
//
//       return <div onClick={handleClick} onMouseOver={handleHover} onMouseOut={handleMouseOut}>{menus}</div>
//     },
//     [treeData],
//   )
// }


export const DuresalesQuery = (props: {
  exportLoading: boolean
  loading: boolean
  onValueChange: (queries: DurgSalesParams) => void
  outClued: () => void
  continueOrder: (v: any, type: string) => void
  alertMessage: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch()

  const otc = useSelector(selectOtctag)

  const materialsCategory = useSelector(selectmaterialsCategory)

  const departmentData = useSelector(selectDepartData)

  const userData = useSelector(sleectUserData)

  const doctors = useSelector(selectDoctors)

  const insuranceArray = useSelector(selectInsuranceArray)

  const [djddChecked, setDjddChecked] = useState<any>(true)

  const [jzcxChecked, setJzcxChecked] = useState<any>(false)

  const [isInTimeRange, setIsInTimeRange] = useState(false)

  // 险种类型树形数据（用 useMemo 避免每次渲染重建导致 dropdownRender 重建）
  const insuranceTreeData = React.useMemo(
    () => [
      { value: 'ALL', label: '全部' },
      { value: 'ZIFEI', label: '自费' },
      {
        value: 'yibao',
        label: '医保',
        children: [
          { value: '0', label: '本地' },
          { value: '1', label: '省内异地' },
          { value: '2', label: '省外异地' },
          { value: '3', label: '省医保' },
        ],
      },
    ],
    [],
  )

  // // 险种类型 Cascader 的 dropdownRender
  // // 通过闭包读写 Form 字段，useCallback 依赖只有 [insuranceTreeData]
  const insuranceDropdownRender = useCascaderDropdownRender(
    insuranceTreeData,
    () => normalizeInsuranceType(form.getFieldValue('insuranceType')),
    (v) => form.setFieldsValue({ insuranceType: v }),
    () => form.submit(),
  )

  const checkTimeRange = () => {
    const now = moment()
    const currentHour = now.hours()

    // 判断当前时间是否在给定的时间段内
    if (
      (currentHour >= 10 && currentHour < 12) ||
      (currentHour === 12 && now.minutes() === 0) ||
      (currentHour >= 14 && currentHour < 16) ||
      (currentHour >= 19 && currentHour <= 23) ||
      (currentHour >= 0 && currentHour < 6)
    ) {
      setIsInTimeRange(true)
    } else {
      setIsInTimeRange(false)
    }
  }

  useEffect(() => {
    checkTimeRange()
  }, [])

  useEffect(() => {
    dispatch(setDoctors(doctors))
  }, [doctors])

  useEffect(() => {
    dispatch(setDoctors(userData))
  }, [userData])

  useEffect(() => {
    dispatch(pageSupplier({ current: 1, size: 100, supplierCategory: 1 }))
    dispatch(DepartmentDate({ current: 1, size: 1000 }))
    dispatch(getAllUserName({ current: 1, size: 1000, stationCategory: 1 }))

    // const [head, tail] = getDateRange(DateRangeType.Today);
    // form.setFieldsValue({
    // [DateRangeFieldName]: DateRangeType.Today,
    //   timeHead: head,
    //   timeTail: tail,
    // });
    form.submit()
  }, [])

  // useEffect(() => {
  //   form.validateFields().then((values) => {
  //     props.onValueChange({
  //       ...form.getFieldsValue(),
  //       state: values?.state ? values.state : null,
  //       otc: otc,
  //       materialsCategory: materialsCategory,
  //     });
  //   });
  // }, [otc, materialsCategory]);

  return (
    <Form
      form={form}
      name='control-hooks'
      onFinish={(fs) => {
        if(!fs?.timeHead && fs?._dateRange == 6){
          return
        }

        const insuranceType = form.getFieldsValue()?.insuranceType
        const parentSelect = insuranceType?.filter((v:any)=> v?.length == 1)
        const sonSelect = insuranceType?.filter((v:any)=> v?.length != 1).map((item: any) => item?.[1])
        const parentSelectStr = parentSelect?.length ? parentSelect.map((item: any) => item?.[0]).join(',') : ''
        const sonSelectStr = sonSelect?.length ? sonSelect.join(',') : ''
        
        dispatch(setDurgSaleCurrent(1));
        props.onValueChange({
          ...fs,
          showPotion: Number(djddChecked),
          isAccurate: Number(jzcxChecked),
          state: fs?.state >0 ? fs?.state : null,
          insuranceType: (parentSelectStr && sonSelectStr) ? `${parentSelectStr},${sonSelectStr}` : (parentSelectStr || sonSelectStr),
        });
      }}
    >
      <Row
        gutter={11}
        style={{ marginBottom: 10, width: '100%' }}
        align='middle'
        justify='space-between'
      >
        <Space>
          <Form.Item name='param' noStyle>
            <Input
              size='middle'
              placeholder='药品名称/助记码/条形码/物资编号'
              allowClear
              style={{
                width: '17rem',
              }}
              onChange={() => form.submit()}
              prefix={<SearchOutlined />}
            />
          </Form.Item>
          {/* <Col span={2}>
          <Form.Item name="state">
            <Select
              placeholder="险种类别"
              allowClear
              suffixIcon={<CaretDownFilled />}
            >
              <Option value="0">注销</Option>
              <Option value="1">启用</Option>
            </Select>
          </Form.Item>
        </Col> */}
          {/* <Col span={2}> */}
          <Form.Item name='showPotion' noStyle>
            <Checkbox
              style={{
                color: '#666',
                display: 'flex',
                alignItems: 'center',
                width: '7.3rem',
              }}
              checked={jzcxChecked}
              onChange={(e) => {
                props?.continueOrder &&
                  props?.continueOrder(e.target.checked, 'jzcx')
                setJzcxChecked(e.target.checked)
              }}
            >
              是否精准查询
            </Checkbox>
          </Form.Item>
          <Form.Item name='state' noStyle>
            <Select
              style={{ width: '7rem' }}
              placeholder='收费类型'
              allowClear
              dropdownClassName={styles.select}
              // suffixIcon={<CaretDownFilled />}
              onChange={() => form.submit()}

            >
              <Option value={0}>全部</Option>
              <Option value={3}>已收费</Option>
              <Option value={5}>已退费</Option>
            </Select>
          </Form.Item>
          <Form.Item name='billingCategory' noStyle>
            <Select
              style={{ width: '7rem' }}
              placeholder='开票项目'
              allowClear
              dropdownClassName={styles.select}
              onChange={() => form.submit()}

            // suffixIcon={<CaretDownFilled />}
            >
              {InvoiceBillingCategories.map((v) => {
                return (
                  <Option value={v} key={v}>
                    {BillingCategoryName(v)}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          {insuranceArray && insuranceArray.length !== 0 && (
            <Form.Item name='insuranceType' noStyle>
              <Cascader
                className={styles.materialsCategoryCascader}
                options={insuranceTreeData}
                onChange={() => form.submit()}
                multiple
                maxTagTextLength={12}
                changeOnSelect
                placeholder='险种类型'
                dropdownRender={insuranceDropdownRender}
                expandTrigger="hover"
              />
            </Form.Item>
          )}
          <Form.Item name='ephedrineTag' noStyle>
            <Select
              style={{ width: '8rem' }}
              placeholder='是否麻黄碱'
              allowClear
              dropdownClassName={styles.select}
              onChange={() => form.submit()}

            // suffixIcon={<CaretDownFilled />}
            >
              <Option value={0}>是否麻黄碱—否</Option>
              <Option value={1}>是否麻黄碱—是</Option>
            </Select>
          </Form.Item>
          <Form.Item name='departmentId' noStyle>
            <Select
              style={{ width: '7rem' }}
              placeholder='开单科室'
              allowClear
              dropdownClassName={styles.select}
              // suffixIcon={<CaretDownFilled />}
              onChange={(value) => {
                form.submit()
                if (value) {
                  dispatch(setDoctors([]))
                  dispatch(getDoctorsInDepartment(value))
                } else {
                  dispatch(setDoctors(userData))
                }
              }}
            >
              {departmentData.map((v: Department) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='doctorId' noStyle>
            <Select
              style={{ width: '7rem' }}
              showSearch
              placeholder='开单医生'
              allowClear
              dropdownClassName={styles.select}
              onChange={() => form.submit()}
            // suffixIcon={<CaretDownFilled />}
            >
              {doctors.map((v: any) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='' noStyle>
            <DateSelect
              initialValue={DateRangeType.Today}
              placeholder='有效期范围'
              style={{ width: '7rem' }}
              namePrefix='time'
              labelPrefix=''
              allowClear={false}
              onChange={() => form.submit()}
            />
          </Form.Item>
          <Button
            loading={props?.loading}
            htmlType='submit'
            type='primary'
            style={{ marginRight: '10px' }}
          >
            查询
          </Button>
        </Space>
        <Space>
          <Form.Item name='isAccurate' noStyle>
            <Checkbox
              style={{
                color: '#666',
                display: 'flex',
                alignItems: 'center',
                float: 'right',
              }}
              checked={djddChecked}
              onChange={(e) => {
                props?.continueOrder &&
                  props?.continueOrder(e.target.checked, 'djdd')
                setDjddChecked(e.target.checked)
              }}
            >
              包含代煎订单
            </Checkbox>
          </Form.Item>
          <Button type='primary' onClick={() => props.outClued()} loading={props?.exportLoading}>
            导出
          </Button>
          {isInTimeRange ? (
            <div
              style={{
                opacity: 0,
                cursor: 'pointer',
                width: '10px',
                height: '30px',
              }}
              onDoubleClick={() => {
                props?.alertMessage && props?.alertMessage()
              }}
            ></div>
          ) : (
            <></>
          )}
        </Space>
      </Row>
      <Row gutter={20} style={{ height: '40px' }}>
        <Col>
          <Form.Item label='OTC分类'>
            <Button
              type='text'
              size='small'
              style={{ color: otc === 0 ? '#027AFF' : '#666' }}
              onClick={() => {
                if (otc === 0) {
                  dispatch(setotcTag(undefined))
                } else {
                  dispatch(setotcTag(0))
                }
              }}
            >
              处方药
            </Button>
            <Button
              type='text'
              size='small'
              style={{ color: otc === 1 ? '#027AFF' : '#666' }}
              onClick={() => {
                if (otc === 1) {
                  dispatch(setotcTag(undefined))
                } else {
                  dispatch(setotcTag(1))
                }
              }}
            >
              OTC
            </Button>
            <Button
              type='text'
              size='small'
              style={{ color: otc === 2 ? '#027AFF' : '#666' }}
              onClick={() => {
                if (otc === 2) {
                  dispatch(setotcTag(undefined))
                } else {
                  dispatch(setotcTag(2))
                }
              }}
            >
              处方药双轨
            </Button>
          </Form.Item>
        </Col>
        <Col>
          <Form.Item label='物资类别'>
            <Button
              type='text'
              size='small'
              style={{
                color: materialsCategory === '0' ? '#027AFF' : '#666',
              }}
              onClick={() => {
                if (materialsCategory === '0') {
                  dispatch(setmaterialsCategory(undefined))
                } else {
                  dispatch(setmaterialsCategory('0'))
                }
              }}
            >
              药品
            </Button>
            <Button
              type='text'
              size='small'
              style={{
                color: materialsCategory === '1' ? '#027AFF' : '#666',
              }}
              onClick={() => {
                if (materialsCategory === '1') {
                  dispatch(setmaterialsCategory(undefined))
                } else {
                  dispatch(setmaterialsCategory('1'))
                }
              }}
            >
              材料
            </Button>
            <Button
              type='text'
              size='small'
              style={{
                color: materialsCategory === '2' ? '#027AFF' : '#666',
              }}
              onClick={() => {
                if (materialsCategory === '2') {
                  dispatch(setmaterialsCategory(undefined))
                } else {
                  dispatch(setmaterialsCategory('2'))
                }
              }}
            >
              器械
            </Button>
            {/* <Button
              type="text"
              size="small"
              style={{
                color: materialsCategory === "3" ? "#027AFF" : "#666",
              }}
              onClick={() => {
                if (materialsCategory === "3") {
                  dispatch(setmaterialsCategory(undefined));
                } else {
                  dispatch(setmaterialsCategory("3"));
                }
              }}
            >
              保健品
            </Button> */}
            <Button
              type='text'
              size='small'
              style={{
                color: materialsCategory === '4' ? '#027AFF' : '#666',
              }}
              onClick={() => {
                if (materialsCategory === '4') {
                  dispatch(setmaterialsCategory(undefined))
                } else {
                  dispatch(setmaterialsCategory('4'))
                }
              }}
            >
              其他
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}
